import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { ICliffhangerAnalyticsResponse } from './cliffhanger-analytics.interface';
import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class CliffhangerAnalyticsService {
  constructor(private readonly _httpService: HttpService) {}

  /**
   * @param autoFallback when true the server ignores the dates above and picks the narrowest window
   * that actually holds clicks, echoing the choice back on `appliedPeriod`. Sent on first load only.
   */
  public getCliffhangerAnalytics(
    startDate: string,
    endDate: string,
    autoFallback = false
  ): Observable<ICliffhangerAnalyticsResponse> {
    return this._httpService.get<ICliffhangerAnalyticsResponse>(
      API_ENDPOINTS.REPORTS_ENDPOINTS.PLATFORM_REPORTS.getCliffhangerAnalytics(
        startDate,
        endDate,
        autoFallback
      )
    );
  }

  public getCliffhangerChartData(
    startDate: string,
    endDate: string,
    selectedIcon: string
  ): Observable<ICliffhangerAnalyticsResponse> {
    return this._httpService.get<ICliffhangerAnalyticsResponse>(
      API_ENDPOINTS.REPORTS_ENDPOINTS.PLATFORM_REPORTS.getCliffhangerChartData(
        startDate,
        endDate,
        selectedIcon
      )
    );
  }
}
